import { Outlet, useMatch } from 'react-router-dom'
import ApplicationStepper from '@/app/pages/program_applications/vendor_application/wizard/ApplicationStepper.tsx'
import { cn } from '@/common/utilities.ts'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useEffect, useState } from 'react'
import ProgressBar from '@/common/components/ProgressBar.tsx'
import { ApplicationSteps, useWizardContext } from './WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

export default function WizardLayout() {
  const { t: translate } = useTranslation()
  const { currentStep } = useWizardContext()
  const locationIsChecklist = useMatch(
    AppRoutePaths.program_application.wizard.index
  )
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    new Promise((resolve) => setTimeout(resolve, 3400))
      .then(() => setLoading(false))
      .catch()
  }, [])

  return (
    <div className="h-full flex flex-col mx-auto max-w-5xl bg-gray-100">
      <div>
        {locationIsChecklist == null && currentStep != null ? (
          <ApplicationStepper
            currentStep={currentStep.id}
            steps={ApplicationSteps}
            className={cn('hidden sm:block')}
          />
        ) : null}
      </div>
      <div className="flex-grow flex flex-col">
        {loading ? (
          <div className="flex-grow grid grid-rows-2 px-10">
            <div className="self-center">
              <h1 className="opacity-0 text-center font-medium text-2xl mb-2 animate-[fade-in_1s_forwards_linear]">
                {translate('welcome_back')}
              </h1>
              <h2 className="opacity-0 text-center text-xl animate-[fade-in_1s_forwards_linear_0.5s]">
                {translate('continue_where_you')}
              </h2>
            </div>
            <div>
              <h1 className="opacity-0 text-center text-lg mb-4 text-gray-600 animate-[fade-in_0.1s_forwards_linear_1.7s]">
                {translate('loading_your_application')}
              </h1>
              <div className="opacity-0 animate-[fade-in_0.1s_forwards_linear_1.7s]">
                <ProgressBar
                  value={0}
                  barCN="animate-[width-animation_1.6s_forwards_linear_1.7s]"
                />
              </div>
            </div>
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  )
}
